import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authApi, getToken, setToken } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ loading: true, ok: false });

  useEffect(() => {
    let cancelled = false;
    const t = getToken();
    if (!t) {
      setState({ loading: false, ok: false });
      return;
    }
    authApi
      .me()
      .then((u) => {
        if (!cancelled) setState({ loading: false, ok: !!u });
      })
      .catch(() => {
        if (!cancelled) {
          setToken(null);
          setState({ loading: false, ok: false });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-ink-black">
        <div className="eyebrow-muted animate-pulse">[ Verifying session ]</div>
      </div>
    );
  }
  if (!state.ok) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
